// import jwt from 'jsonwebtoken';
import * as actionTypes from '../actions/profile';
import { CUBEJS_API_TOKEN } from 'shared/utils/constants';

const initialState = {
  me: null
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ME_SUCESS: {
      /* eslint-disable-next-line */
      const { id: accountId, userId, name, firstName, lastName, email } = action.payload.data.myAccount[0];
      /* eslint-disable-next-line */
      // const cubejsToken = jwt.sign(
      //   { u: { id: userId, a_id: accountId } },
      //   CUBEJS_API_TOKEN,
      //   { expiresIn: '30d' }
      // );
      // document.cookie = `cubejs_jwt=${cubejsToken};path=/`;
      const me = {
        name,
        userId,
        accountId,
        cubejsToken: null,
        firstName,
        lastName,
        email
      };
      return {
        ...state,
        me
      };
    }
    default: {
      return state;
    }
  }
};

export default profileReducer;
